import { NgModule } from '@angular/core';
import { SafeUrlPipe } from '@app/pipes/safeUrl.pipe';

@NgModule({
  declarations: [SafeUrlPipe],
  exports: [SafeUrlPipe],
})
export class PipesModule {}
